import { FileField } from '@sitecore-jss/sitecore-jss-nextjs';

export const useVideoSource = (sources: FileField[]): string | undefined => {
  for (const source of sources) {
    if (source?.value?.src) {
      return source.value.src;
    }
  }
  return undefined;
};
